import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Il sito deve mostrare sempre l'ultima versione pubblicata.
// Rimuoviamo i vecchi Service Worker e le cache create dalle versioni precedenti.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));

      if ("caches" in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
      }
    } catch (error) {
      console.warn("Pulizia aggiornamenti non completata:", error);
    }
  });
}

// Elimina una sola volta eventuali impostazioni locali obsolete,
// conservando i dati necessari per mantenere l'accesso.
const STORAGE_VERSION = "3";
const storedVersion = localStorage.getItem("app_version");

if (storedVersion !== STORAGE_VERSION) {
  const keysToKeep = ["token", "user"];
  const savedData = {};

  keysToKeep.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value) savedData[key] = value;
  });

  localStorage.clear();

  Object.entries(savedData).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });

  localStorage.setItem("app_version", STORAGE_VERSION);
}
